export const appConfig = {
  websiteUrl: "https://samsonautoelectricals.com",
  serverApiVersion: "v1",
  dataSource: "airtable",
  serverBaseUrl: process.env.REACT_APP_SERVER_BASE_URL,

  contact: {
    ccNumber: "+919311665000",
    ccWhatsapp: "https://wa.me/919911665000",
    email: "hi@noblewiring.com",
  },
};
